import React from 'react';
import { Link } from 'react-router-dom';

const MenuMobileRegularPtBr = ({toggleMenuType}) => {
  return (
    <menu>
      <li onClick={ (e) => { toggleMenuType('products') }}>
        <span className="arrow-right">Produtos</span>
      </li>
      <li>
        <a href="https://www.instagram.com/meuambienteguararapes/?hl=pt-br"  rel="noopener noreferrer" target="_blank">Ambientes</a>
      </li>
      <li>
        <Link to="/conteudos">Conteúdos</Link>
      </li>
      <li>
        <a href="https://loja.guararapes.com.br/" rel="noopener noreferrer" target="_blank">Loja</a>
      </li>
      <li>
        <Link to="/onde-encontrar">Onde encontrar</Link>
      </li>
      <li onClick={ (e) => { toggleMenuType('about') }}>
        <span className="arrow-right">A Guararapes</span>
      </li>
      <li>
        <Link to="/contato">Contato</Link>
      </li>
      <li>
        <Link to="/">Investidores</Link>
      </li>
    </menu>
  )
}
          
export default MenuMobileRegularPtBr;